import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GasMonitorReading, InstrumentStatus, SensorStatusToColor } from '@weavix/models/src/gas/gas';
import { Person } from '@weavix/models/src/person/person';
import moment from 'moment';
import { BadgeUpdate } from '@weavix/models/src/badges/badge-update';
import { FacilityService } from 'weavix-shared/services/facility.service';
import { MapService } from 'weavix-shared/services/map.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-gas-monitor-readings',
    templateUrl: './gas-monitor-readings.component.html',
    styleUrls: ['./gas-monitor-readings.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
    ],
})
export class GasMonitorReadingsComponent implements OnChanges {
    @Input() person: Person;

    SensorStatusToColor = SensorStatusToColor;

    private facilityTimezone: string;
    private latestBadge: BadgeUpdate;
    latestGasMonitorBadge: GasMonitorReading;

    constructor(
        private readonly mapService: MapService,
        private readonly facilityService: FacilityService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.person) {
            this.setUp();
        }
    }

    get readingTime(): string { return moment(this.latestGasMonitorBadge.updated).clone().tz(this.facilityTimezone).format('MM/DD/YYYY, hh:mm A'); }
    get hasUpdatedData(): boolean { return !!this.latestGasMonitorBadge && (new Date(this.latestBadge.date)?.getTime() - new Date(this.latestGasMonitorBadge.updated)?.getTime()) < (1000 * 120); }
    get hasReadings(): boolean { return !!this.latestGasMonitorBadge?.readings?.length; }
    get showReadings(): boolean { return this.hasUpdatedData && this.hasReadings && this.latestGasMonitorBadge?.status !== InstrumentStatus.Unpaired; }

    private setUp(): void {
        this.facilityTimezone = this.facilityService.getCurrentFacility()?.timezone || moment.tz.guess();
        const dvrData = this.mapService.dvrPlaybackMode ? this.mapService.getDvrMinuteDataPeople(this.mapService.dvrTimestamp) : null;
        this.latestBadge = dvrData?.[this.person.id]?.badge ?? this.person.badge;
        this.latestGasMonitorBadge = this.latestBadge?.gasMonitor;
    }
}
